import { ActivityIndicator } from "react-native";
import { FormattedMessage } from "react-intl";
import Text from "@ticketingplatform/ui/dist/components/styles/Typography";
import { Box } from "components/styles";

import { useEventOccurrence } from "./hooks";
import EventHeading from "./partials/EventHeading";
import EventActions from "./partials/EventActions";

const EventDetails: React.FC = () => {
  const { eventOccurrence, loading } = useEventOccurrence();

  if (loading) {
    return <ActivityIndicator />;
  }

  if (!eventOccurrence) {
    return (
      <Text textAlign="center" margin="2rem">
        <FormattedMessage defaultMessage="Event not found" />
      </Text>
    );
  }

  return (
    <Box padding="0.5rem">
      <EventHeading {...eventOccurrence} />
      <EventActions {...eventOccurrence} />
    </Box>
  );
};

export default EventDetails;
